@if (enableAnnotationSignal()) {
  <div class="audio-component-container">
    <mtm-audio-annotation
      class="w-100 h-100"
      [projectId]="projectIdSignal()"
      [sectionId]="sectionIdSignal()"
      [subsectionId]="subsectionIdSignal()"
      [typeId]="typeIdSignal()"
      [item]="itemSignal()"
      [hideAnnotationToolbar]="hideAnnotationToolbarSignal()"
      [participants]="projectParticipantsSignal()"
      [annotations]="annotationsSignal()"
      [authUser]="userInfoSignal()"
      [enableAudioAnnotation]="enableAnnotationSignal()"
      [hasEditPermission]="hasEditPermissionSignal()"
      [assetListTemplate]="assetListTemplate"
      [assetInfoTemplate]="assetInfoTemplate"
      [reviewLink]="subsectionStateSignal()?.reviewLink || null"
      [instanceId]="instanceIdSignal() ?? ''">
    </mtm-audio-annotation>
  </div>
} @else {
  <div class="audio-container-wrapper">
    <div class="position-relative asset-container">
      <div
        class="col w-100 h-100 audio-container"
        [ngClass]="{
          'min-h-250': !portfolioPreviewSignal(),
          'portfolio-preview': portfolioPreviewSignal(),
        }">
        @if (uuid) {
          <div class="wave-form-container" id="{{ uuid }}"></div>
        }
        <audio class="w-100 audio" controls #mtmAudioPlayer [preload]="audioPreloadMethod">
          <source [src]="itemSignal()?.signedURL" />
        </audio>
      </div>
      <ng-container [ngTemplateOutlet]="assetListTemplate"></ng-container>
      <ng-container [ngTemplateOutlet]="assetInfoTemplate"></ng-container>
    </div>
  </div>
}
